import gql from 'graphql-tag';

export const queryForMonLogs = gql`
  query queryForMonLogs(
    $limit: Int
    $page: Int
    $query: MonLogSortOrQuery
    $sort: MonLogSortOrQuery
  ) {
    queryForMonLogs(limit: $limit, page: $page, query: $query, sort: $sort) {
      items {
        id
        logStatus
        logId
        statusSummary
        createdAt
        createdBy
        callTypes
        facilityName
        facilityUid
        state
        county
        township
        facilityType
        pipeline
        firstName
        lastName
      }
      totalRecords
    }
  }
`;
